<!--
  Action dialog "Satz manuell anlegen" (04-frontend.md §7).

  IMPORTANT: This file contains NO form HTML. Ereigniszeile, Provisionsart and Berater are rendered
  by the transient form widget built from the MvsFormDto in the TS — repo precedent
  wf-process-start.component.html, identical to the sibling dialogs. Only the dialog frame, the
  MANUAL note and the action buttons live here.
-->
<p-dialog
        header="Satz manuell anlegen"
        [visible]="visible"
        (visibleChange)="handleVisibleChange($event)"
        (onShow)="handleShow()"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{width: '44rem'}"
        [breakpoints]="{'960px': '90vw'}"
        styleClass="cp-provision-agent-manual-rate-dialog">

    @if (!formWidget) {

        <p-skeleton height="14rem"></p-skeleton>

    } @else {

        <!-- Context: the Abrechnungskonto the pane was opened from -->
        @if (provisionAgentName) {
            <div class="flex flex-wrap align-items-center gap-2 mb-3">
                <span class="text-color-secondary text-sm">Abrechnungskonto der Liste</span>
                <span class="font-medium">{{ provisionAgentName }}</span>
            </div>
        }

        <!-- The dialog opens with the action available (optimistic, see the class TSDoc); this
             banner appears only after the SERVER refused with a 403. -->
        @if (!canAgentChange) {
            <p-message severity="warn" styleClass="w-full mb-3">
                <span>
                    Der Server hat das Anlegen verweigert: Ihnen fehlt das Recht
                    <strong>cp_agentChange</strong>.
                </span>
            </p-message>
        }

        <!-- What MANUAL means — the operator should know before, not after -->
        <p-message severity="info" styleClass="w-full mb-3">
            <span>
                Der Satz wird als <strong>manuell</strong> angelegt und von künftigen
                Berechnungsläufen weder überschrieben noch gelöscht.
            </span>
        </p-message>

        <!-- Capture: metadata-driven form widget -->
        <mvs-widget
                [widgetData]="formWidget"
                (onGenericEvent)="handleGenericEvent($event)">
        </mvs-widget>

        @if (failureMessage) {
            <p-message severity="error" [text]="failureMessage" styleClass="w-full mt-3"></p-message>
        }

    }

    <ng-template pTemplate="footer">
        <p-button
                label="Abbrechen"
                icon="fa-regular fa-xmark"
                severity="secondary"
                [text]="true"
                (onClick)="handleClose()">
        </p-button>

        <p-button
                label="Satz anlegen"
                icon="fa-regular fa-check"
                severity="primary"
                [loading]="busy"
                [disabled]="!submittable"
                [pTooltip]="submitTooltip"
                tooltipPosition="top"
                (onClick)="handleCreate()">
        </p-button>
    </ng-template>

</p-dialog>
